import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useAPI } from '../../../state';
var METRIC_SETTINGS_API = '/api/metricSetting';
var METRIC_SETTINGS_UPDATE_API = '/api/metricSetting/{planId}';
// Get settings API
export var useMetricSettingsAPI = function () {
  return useAPI(METRIC_SETTINGS_API);
};
// Update settings API
export var useUpdateMetricSettingsAPI = function (planId) {
  return useAPI(METRIC_SETTINGS_UPDATE_API, {
    planId: planId
  }, 'PUT');
};
var selectMetricSettingsData = function (data) {
  return data;
};
var createMetricSettingsSelector = function () {
  return createSelector(selectMetricSettingsData, function (metricSettings) {
    return metricSettings;
  });
};
export var useMetricSettings = function () {
  var data = useMetricSettingsAPI()[0].data;
  var selectMetric = useMemo(function () {
    return createMetricSettingsSelector();
  }, []);
  return selectMetric(data);
};